import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

import { commonContentAttributes } from "./commonContentAttributes";

export const min_okpo1: SugarElementInfo = {
    name: "min_okpo1",
    availableChildren: { type: AvailableChildrenType.Any },
    attributes: commonContentAttributes,
};
